var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99668 1.33333C4.29974 1.33333 1.29932 4.32 1.29932 8C1.29932 11.68 4.29974 14.6667 7.99668 14.6667C11.6936 14.6667 14.694 11.68 14.694 8C14.694 4.32 11.6936 1.33333 7.99668 1.33333ZM2.63879 8C2.63879 5.05333 5.03645 2.66667 7.99668 2.66667C9.23569 2.66667 10.3742 3.08667 11.2784 3.79333L3.77064 11.2667C3.06072 10.3667 2.63879 9.23333 2.63879 8ZM4.71497 12.2067C5.61912 12.9133 6.75767 13.3333 7.99668 13.3333C10.9569 13.3333 13.3546 10.9467 13.3546 8C13.3546 6.76667 12.9326 5.63333 12.2227 4.73333L4.71497 12.2067Z",
    fill: "#C3C9D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.9f681be685b1cf479880fbe28b5d01ac.svg";
export { ForwardRef as ReactComponent };